<!-- @mouseleave="isMouseOver=false" @mouseenter="isMouseOver=true"-->
<template>
    <div class="col-picker" id="collectionPicker1" >

        <div class="top">
            <div class="title">Save to collection</div>
            <slot name="close"></slot>
        </div>

        <div class="items">
            <!-- item template 
            {{collections}}
            <div class="item">
                <div class="itemPic"></div>
                <div class="itemName">Collection Name</div>
                <div class="itemBtn">Save</div>
            </div>
            <div class="item">
                <div class="itemPic"></div>
                <div class="itemName">Collection Name</div>
                <div class="itemBtn">Save</div>
            </div>            
            [ { "col_id": 2, "col_name": "dubi4", "user_id": null,
             "user_token": null, "col_order_id": 0, "created_date": "2022-01-05T12:07:43.903", "is_public": true, "auid": "e7RzYBEXFYBi8NcFGtOdzWYZ6Yh3SeXY" } ]
            @click="addItemToCollection(item.col_id)"
            -->
            <!-- problem, cant bind loop : -->
            
            <!-- Add to list -->
            <div>
                <div class="item" 
                    :title="localize('Add to list')"
                    v-for="(item, index) in collections.children" :key="index" 
                    @click="addItemToCollection(item.collection.col_id)">
                    <div class="itemPic" :style="`background-image:url(${getColPic(index)})`"></div>
                    <div class="itemName">{{item.collection.col_name}}</div>
                    
                    <!-- checkmark animation -->
                    <div class="cm" 
                        v-if="showCheckMark && collectedTo==item.collection.col_id">
                        <checkmark></checkmark>
                    </div>

                    <a class="showColBtn" :title="localize('View List')" @click="showCollection(item.collection.col_id)">
                        <i class="fal fa-folder-open"></i>
                    </a>


                    <!--<div class="itemBtn" @click="addItemToCollection(item.col_id)">Save</div>-->
                </div>
            </div>
            
            <!--Create new collection-->
            <div class="item" v-if="collections.children.length<30">
                <div class="itemAddIcon"><i class="fal fa-plus"></i></div>
                <div class="itemName" @click="enterNewName">                    
                    <input v-model="newColName" type="text" placeholder="New collection name..." />
                    <div class="itemBtn" @click="createCollection()">Create</div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import checkmark from './fx/checkmark.vue';
export default {
  components: { checkmark },
  props: {
    activeItem: {
      type: Number,
      default: -1
    }
  },    
  data() {
    return {
        //tempcollections:[],//{ "col_id": 2, "col_name": "dubi4", "user_id": null, "user_token": null, "col_order_id": 0, "created_date": "2022-01-05T12:07:43.903", "is_public": true, "auid": "e7RzYBEXFYBi8NcFGtOdzWYZ6Yh3SeXY" }
        newColName:'',
        isMouseOver:false,
        activeItemID:-1,
        collectedTo:-1,
        showCheckMark:false
    };
  },
  methods: {
      ...mapActions(["setItemToCollect","setCollectionsList","setActiveCollection","showCollectionsViewer"]),
      getColPic(index)
      {
          var vm=this;
          var _colDataItems = vm.collections.children[index].items;
          var _colLastItemAdded = _colDataItems[_colDataItems.length-1].product.CatalogNo;
            return "https://www.mis-implants.com/upload/catalog/products/thumbs/"+_colLastItemAdded+".png";
            //return "https://www.mis-implants.com/upload/catalog/products/thumbs/V3-13390.png";
      },
      showCollection(cid)
      {
          this.setItemToCollect(-1);        //close the picker
          this.setActiveCollection(cid);    //change the active collection
          this.showCollectionsViewer();     //show the viewer
      },
      enterNewName() {

      },
      addItemToCollection(CollectionID)
      {
        var vm=this;
        var ProductID = vm.collections.activeitem;
        var apiURL = "https://api.mis-implants.com/api/collections?"+
            "AUID="+vm.auid+"&CollectionId="+CollectionID+"&ItemID="+ProductID;
        vm.collectedTo = CollectionID;                        
        vm.postToApi(apiURL,true);
      },
      createCollection()
      {
        var vm=this;
        var CollectionName = vm.newColName;
        if(CollectionName.length==0){return false;}
        var ProductID = vm.collections.activeitem;
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+vm.auid+"&Name="+CollectionName+"&ItemID="+ProductID;
        vm.postToApi(apiURL,true);
      },
      readCollections()
      {
        var vm=this;
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+vm.auid;
        fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
        .then(function(response){return response.json();})
        .then(function(response){
            //vm.$set(vm, "collectionsList", response);
            //vm.$set(vm.tempcollections, response);
            vm.setCollectionsList(response);//update the list
        });         
      },
      closePopup()
      {
          this.setItemToCollect(-1);
      },
      postToApi(apiURL,showCheckAnimation)
      {
        var vm=this;
        fetch(apiURL, {
          method: "POST",
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
          referrerPolicy: "no-referrer", // no-referrer, *client
          body: ""
        })
        .then(function(response) {            
            return response.json();//console.log("FIRST THEN RESPONSE  < ", response);
        })
        .then(
            async function(json) 
            {
              console.log("response  >> ", json);
              if (json.status && json.status && json.status === "error") 
              {
                console.log("[fetch|error] register user >> ", json);
                throw new Error(json.message);
              } 
              else {
                  if(showCheckAnimation)
                  {
                      vm.showCheckMark=true;
                      setTimeout(() => {
                        vm.closePopup();
                      }, 1800);
                  }else{
                    vm.closePopup();
                  }                  
                  vm.readCollections();//update the list
              }
            },
            error => {
              vm.sending = false;
              console.log("[fetch|error] register user >> ", error);
              throw new Error(error);
            }
          );          
      }
  },
  mounted()
  {
    var vm=this;            
    vm.readCollections();
  },
  created(){
    this.activeItemID = this.activeItem;
  },
  watch:
  {
    activeItem() {
      this.activeItemID = this.activeItem;
    },
  },
  computed: 
  {
    ...mapState(["collections", "auid"]),
    ...mapGetters(["getItemToCollect","getAUID"])
  }
};
</script>

<style scoped>
    .col-picker
    {
        z-index: 2000;
        position: fixed;
        top: 50%;
        left:50vw;
        width: 450px;
        height: 500px;
        background-color: #fff;
        color: black;
        border-radius: 15px;
        transform: translate(-50%,-50%);          
        box-shadow: 0px 0px 36.1px 1.9px rgba(107, 107, 107, 0.25);
    }
    .top
    {
        position: relative;
        width: 100%;
        text-align: left;
        left: 0px;
        padding: 30px;
    }
    .top .title
    {
            color: #31a9f6;
            font-size: 18px;
            font-weight: 300 !important;
    }
    .btnClose
    {        
        position: absolute;
        top:20px;right: 15px;
        width: 30px;height: 30px;
        cursor: pointer !important;
        font-size: 30px;
        opacity: 0.3;
    }
    .btnClose:hover
    {
        opacity: 1;
    }
    .items
    {
        width: 100%;
        height: calc(100% - 120px);
        overflow-y: scroll;
    }
    .items .item
    {
        cursor: pointer;
        clear: both;
        width: 100%;
        background-color: #fff;
        padding: 20px 30px;
        position: relative;
        height: 60px;
    }
    .showColBtn
    {
        cursor: pointer !important;
        color: #ccc;
        display: inline-block;
        padding: 8px 15px;
        position: absolute;
        top: 13px;
        right: 30px;
        font-weight: 300 !important;
    }
    .showColBtn:hover
    {
        color: #000;
    }

    .items .item:hover
    {
        background-color: #f8f8f8;
    }
    .itemPic
    {
        background-size: cover;        
        background-color: #f9f9f9;
        width: 40px;
        height: 40px;
        float: left;
        border-radius: 20px;
        position: absolute;
        top: 10px;
    }
    .itemAddIcon
    {
        width: 40px;
        height: 40px;
        float: left;
        border-radius: 20px;
        position: absolute;
        top: 10px;
        background-color: #f9f9f9;
        text-align:center;
    }
    .itemAddIcon i
    {
        font-size: 24px;position: relative;top:7px;
        
    }
    .itemName
    {
        float: left;
        padding-left: 50px;
        width: calc(100% - 100px);
    }
    .itemBtn
    {
        background-color: #31a9f6;
        border-radius: 20px;
        color: #fff;
        display: inline-block;
        float: right;
        padding: 8px 15px;
        position: absolute;
        top: 13px;
        right: 30px;
        cursor: pointer;
        opacity: 0;
        font-weight: 300 !important;

    }
    .items .item:hover .itemBtn
    {
        opacity: 1;
    }

    .itemName input
    {
        padding: 8px 5px !important;
        width: 100%;
        border:solid 1px #ccc;
        position: relative;
        top:-7px
    }
    .itemName input:focus
    {
        outline: none;
    }
    .item
    {
        cursor: pointer;
    }
    .item .cm
    {
        position: relative;
        transform: scale(0.4);
        top: -24px;
        left: 0px;
        display: inline-block;
    }


    @media only screen and (max-width: 800px) {
        .col-picker
        {
            width: 100vw;
            height: 100vh;
            top:0px;left: 0px;
            transform: none;
        }        
    }

</style>
